import { render, staticRenderFns } from "./synapv.vue?vue&type=template&id=e4176af6"
import script from "./synapv.vue?vue&type=script&lang=js"
export * from "./synapv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports